module.exports = __webpack_public_path__ + "img/DE03986.bfc703b5.png";